module.exports = __webpack_public_path__ + "img/studio-agency.4296cec8.webp";